module.exports = __webpack_public_path__ + "img/play-store-btn.2edc7493.svg";